module.exports = __webpack_public_path__ + "img/active_marker.3913b44a.svg";